import { Routes, Route } from 'react-router-dom';
import Home from '../pages/CareFacilityLocater/Home';
import Search from '../pages/CareFacilityLocater/Search';
import ExternalRedirect from '../components/ExternalRedirect';

const AppRoutes = (props) => {
    return (
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/search' element={<Search />} />
            <Route path='*' element={<ExternalRedirect url="https://senioradvocacyservices.org/" />} />
        </Routes>
    );
};

export default AppRoutes;
